<template>
    <div>
        <Dialog 
            id="dialogPrintList"
            v-model:visible="showDialog" 
            :modal="true" 
            :style="{ width: '50vw' }"
            :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
            :closeOnEscape="false"
            :closable="false">
            <template #header>
                <div class="grid">
                    <div class="col-xs-12">
                        <h2 class="mt-0 mb-0 pb-0">IMPRIMIR LISTADOS</h2>
                    </div>
                </div>
            </template>

            <div class="card mt-1">
                <form @submit.prevent="handleReservation">
                    <div class="formgrid grid">
                        <div class="field col-12 col-sm-6 col-md-6 mt-3">
                            <label for="sector">Sector</label>
                            <MultiSelect 
                                id="sector" 
                                ref="sector" 
                                v-model="filter.group" 
                                placeholder="Todos"
                                optionValue="id"
                                optionLabel="description"
                                :filter="true"
                                :options="groups"
                                :showClear="true" 
                                class="w-full"
                            >
                            <template #option="slotProps">
                                <div class="flex align-items-center">
                                    <div>{{ `${slotProps.option.description} - ${slotProps.option.name}` }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        </div>
                        <div class="field col-12 col-sm-6 col-md-6 mt-3">
                            <label for="noche">Noche</label>
                            <NightPicker @handleChange="setNight"/>
                        </div>
                        <div class="field col-12 mt-3">
                            <label for="usuario">Usuario</label>
                            <MultiSelect 
                                id="usuario" 
                                ref="usuario" 
                                v-model="filter.user" 
                                placeholder="Todos"
                                optionValue="id"
                                optionLabel="name"
                                :filter="true"
                                :options="users"
                                :showClear="true" 
                                class="w-full"
                            />
                        </div>
                        <div class="field col-12 mt-3">
                            <label for="tipo">Tipo</label>
                            <div class="text-center">
                                <Button 
                                    class="p-button-sm p-button-secondary m-1" 
                                    label="LISTADO" 
                                    @click="handlePrint('list')"
                                    icon="fas fa-print" />

                                <Button 
                                    class="p-button-sm p-button-secondary m-1" 
                                    label="ETIQUETAS" 
                                    @click="handlePrint('tags')"
                                    icon="fas fa-print" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
            <template #footer>
                <div class="grid">
                    <div class="col-12 mt-4 text-left">
                        <Button 
                            class="p-button-sm p-button-outlined p-button-danger" 
                            label="CERRAR" 
                            @click="handleClose"
                            icon="fas fa-times" />
                    </div>
                </div>
            </template>
        </Dialog>

        <!-- Dialog para visualizar PDF -->
        <Dialog 
            v-model:visible="showPdfDialog" 
            :modal="true" 
            :style="{ width: '95vw', height: '95vh' }"
            :maximizable="true"
            :closeOnEscape="true"
            header="Vista Previa del Reporte">
            
            <iframe 
                v-if="pdfUrl"
                :src="pdfUrl" 
                style="width: 100%; height: 80vh; border: none;">
            </iframe>
            
            <template #footer>
                <div style="display: flex; width: 100%;" class="mt-2">
                    <div style="flex:1; display: flex; justify-content: flex-start; align-items: center;">
                        <Button 
                            class="p-button-sm p-button-outlined p-button-danger" 
                            label="CERRAR" 
                            @click="closePdfDialog"
                            icon="fas fa-times" />
                    </div>
                    <div style="flex:1; display: flex; justify-content: flex-end; align-items: center; gap: 12px;">
                        <Button 
                            class="p-button-sm p-button-outlined p-button-primary" 
                            style="margin-right:12px;" 
                            label="DESCARGAR PDF" 
                            @click="downloadPdf"
                            icon="fas fa-file-pdf" />
                        <Button 
                            class="p-button-sm p-button-primary" 
                            label="IMPRIMIR" 
                            @click="printPdf"
                            icon="fas fa-print" />
                    </div>
                </div>
            </template>
        </Dialog>

    </div>
</template>

<script>
    import apiService from '../../../services/apiService';

    export default {
        name: 'Detail',
        props:{
            show: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                showDialog: false,
                filter: {
                    date: null,
                    user: [],
                    group:[],
                    type: '',
                },
                users: [],
                groups: [],
                showPdfDialog: false,
                pdfUrl: null,
                pdfBlob: null,
            }
        },
        created(){
            this.showDialog = this.show
            this.getUsers();
            this.getGroups();

            this.filter.date = localStorage.getItem('date')
        },

        methods: {
            handlePrint(type){
                this.filter.type = type;
                try{
                    if(!this.filter.date) throw "Debe seleccionar una noche para continuar."

                    apiService.Reservation.prints(this.filter)
                    .then((blob) => {
                        // Guardar el blob y crear URL
                        this.pdfBlob = blob;
                        this.pdfUrl = window.URL.createObjectURL(blob);
                        
                        // Mostrar el dialog con el PDF
                        this.showPdfDialog = true;
                    }).catch((e) => {
                        this.FormRequestFail(e)
                    })

                }catch(e){
                    this.FormRequestFail(e, true)
                }
            },
            closePdfDialog(){
                // Limpiar el URL del blob
                if (this.pdfUrl) {
                    window.URL.revokeObjectURL(this.pdfUrl);
                    this.pdfUrl = null;
                    this.pdfBlob = null;
                }
                this.showPdfDialog = false;
            },
            downloadPdf(){
                if (!this.pdfBlob) return;
                
                // Crear nombre del archivo
                const tipo = this.filter.type === 'list' ? 'listado' : 'etiquetas';
                const fecha = new Date().toISOString().slice(0, 10);
                const filename = `${tipo}_${fecha}.pdf`;
                
                // Descargar el PDF
                const link = document.createElement('a');
                link.href = this.pdfUrl;
                link.download = filename;
                link.click();
            },
            printPdf(){
                if (!this.pdfUrl) return;
                
                // Abrir en nueva ventana solo para imprimir
                const printWindow = window.open(this.pdfUrl);
                if (printWindow) {
                    printWindow.onload = () => {
                        printWindow.print();
                    };
                }
            },
            setNight(night){
                this.filter.date = night
            },
            async getUsers(){
                apiService.User.getCombo()
                .then((result) => {
                    this.users = result
                })
            },
            async getGroups(){
                apiService.Group.get()
                .then((result) => {
                    this.groups = result
                })
            },
            handleClose(){
                this.showDialog = false
                this.$emit('handleClose')
            }
        }
    }
</script>
